var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticStyle:{"width":"100%"},attrs:{"multiple":true,"size":"mini","disabled":_vm.disabled},model:{value:(_vm.currentVal),callback:function ($$v) {_vm.currentVal=$$v},expression:"currentVal"}},_vm._l((_vm.userList),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.realName,"value":item.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }